import {
  ADD_CANDIDATE_FAILED,
  ADD_CANDIDATE_SUCCESS,
  CONFIRMED_GET_CANDIDATES,
  CONFIRMED_GET_CANDIDATE_JOB,
  CONFIRMED_GET_CANDIDATE,
  GET_CANDIDATE_FAILED_ACTION,
  UPDATE_CANDIDATE_FAILED,
  UPDATE_CANDIDATE_SUCCESS,
} from "../../actions/Candidates/candidateTypes";

const initialState = {
  candidates: [],
  pagination: null,
  candidateJobs: [],
  selectedCandidate: {},
  errorMessage: "",
  successMessage: "",
  showLoading: false,
};

export function CandidateReducer(state = initialState, action) {
  switch (action.type) {
    case CONFIRMED_GET_CANDIDATE_JOB:
      return {
        ...state,
        candidateJobs: action.payload,
        showLoading: false,
      };

    case CONFIRMED_GET_CANDIDATES:
      const hasPagination = action.payload && action.payload.data && action.payload.pagination;
      return {
        ...state,
        candidates: hasPagination ? action.payload.data : (Array.isArray(action.payload) ? action.payload : []),
        pagination: hasPagination ? action.payload.pagination : null,
        showLoading: false,
      };

    case CONFIRMED_GET_CANDIDATE:
      return {
        ...state,
        selectedCandidate: action.payload,
        showLoading: false,
      };

    case GET_CANDIDATE_FAILED_ACTION:
    case ADD_CANDIDATE_FAILED:
    case UPDATE_CANDIDATE_FAILED:
      return {
        ...state,
        errorMessage: action.payload,
        successMessage: "",
        showLoading: false,
      };

    case ADD_CANDIDATE_SUCCESS:
    case UPDATE_CANDIDATE_SUCCESS:
      return {
        ...state,
        errorMessage: "",
        successMessage: action.payload,
        showLoading: false,
      };

    default:
      return state;
  }
}
